import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_shapes.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconShapes = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconShapes;
